import draggable from "vuedraggable";

export default {
    components: {
        draggable,
    },
    data() {
        return {
            drag: false,
            dragCrossResources: false,
            pivotResources: '',
            startLoadResources: false,
            pivotCrossResources: '',
            enableCrossresources: false,
            form: {
                resources: [],
                crossresources: [],
            },
            help: {
                resources: {
                    list: {
                        title: this.$t('global.resources.list.title'),
                        placeholder: this.$t('global.resources.list.placeholder'),
                        model: {
                            name: this.$t('global.resources.list.model.name'),
                            no_abstract: this.$t('global.resources.list.model.no_abstract'),
                        },
                        actions: {
                            select: this.$t('global.resources.list.actions.select'),
                            add: this.$t('global.resources.list.actions.add'),
                            add_cross: this.$t('global.resources.list.actions.add_cross'),
                        }
                    },
                    items: {
                        resources: {
                            title: this.$t('global.resources.items.resources.title'),
                        },
                        crossresources: {
                            title: this.$t('global.resources.items.crossresources.title'),
                            name: this.$t('global.resources.items.crossresources.name'),
                            exclude: this.$t('global.resources.items.crossresources.exclude'),
                            no_report: this.$t('global.resources.items.crossresources.no_report'),
                            field: {
                                name: this.$t('global.resources.items.crossresources.field.name'),
                                description: this.$t('global.resources.items.crossresources.field.description'),
                            }
                        }
                    }
                }
            },
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: this.readonlyFormItem,
                ghostClass: "ghost"
            };
        },
        resourcesSelected() {
            return this.form.resources.map(item => {
                return item.id;
            });
        },
        tblFilters() {
            return {
                exclude: this.resourcesSelected,
            };
        }
    },
    methods: {
        onDragStart: function(evt) {
            this.drag = true;
        },
        onDragEnd: function(evt) {
            this.drag = false;
            // var itemEl = evt.item;  // dragged HTMLElement
            // evt.oldIndex;  // element's old index within old parent
            // evt.newIndex;  // element's new index within new parent
            this.updateOrderItems();
        },
        updateOrderItems: function() {
            if(this.pivotResources) {
                this.form.resources.forEach( (item, index)=> {
                    item[this.pivotResources].order = index+1;
                });
            }
        },
        addResource(resource, idx, callback) {
            if(this.readonlyFormItem){
                return;
            }

            if (!this.form.resources.find(x => x.id === resource.id)){
                if(this.pivotResources && !(this.pivotResources in resource)){
                    this.$set(resource, this.pivotResources, {'order': this.form.resources.length + 1});
                }

                this.form.resources.push(resource);
                if(callback && typeof callback === "function"){
                    callback(resource.id, idx);
                }
            }
        },
        removeResource(idx) {
            if(this.readonlyFormItem){
                return;
            }

            this.$refs.tblResources.prependItem(this.form.resources[idx]);
            this.form.resources.splice(idx, 1);
        },
        forceDirtyForm(value, name="resources", scope = 'form') {
            const matchOptions = {
                name: name,
                scope: scope
            };
            const field = this.$validator.fields.find(matchOptions);
            if (field) {
                field.setFlags({
                    changed: true,
                    dirty: true,
                    valid: field.required ? value && value.length>0 : true,
                 });
            }
        },
        getServiceCode(service) {
            return service?service.service.code:'';
        },
        getClassServiceCode(service) {
            let code = service?service.service.code:'';
            let cl = 'badge-secondary';
            switch(code.toLowerCase()) {
                case 'wms':
                    cl = 'badge-info';
                    break;
                case 'wfs':
                    cl = 'badge-warning';
                    break;
                default:
                    cl = 'badge-dark';
            }
            return cl;
        },
        getColorServiceCode(service) {
            let code = service?service.service.code:'';
            let cl = 'text-secondary';
            switch(code.toLowerCase()) {
                case 'wms':
                    cl = 'text-info';
                    break;
                case 'wfs':
                    cl = 'text-warning';
                    break;
                default:
                    cl = 'text-dark';
            }
            return cl;
        },

        onDragStartCrossResources: function(evt) {
            this.dragCrossResources = true;
        },
        onDragEndCrossResources: function(evt) {
            this.dragCrossResources = false;
            // var itemEl = evt.item;  // dragged HTMLElement
            // evt.oldIndex;  // element's old index within old parent
            // evt.newIndex;  // element's new index within new parent
            // this.updateOrderItems();
        },
        eligibleForCrossResource: function(service){
            return this.getServiceCode(service).toUpperCase() === 'WFS';
        },
        enableAddCrossResource: function(service){
            return this.enableCrossresources && this.getServiceCode(service).toUpperCase() === 'WFS';
        },
        addCrossResource(resource, idx, callback) {
            if(this.readonlyFormItem){
                return;
            }

            if (!this.form.crossresources.find(x => x.id === resource.id)){
                if(!(this.pivotCrossResources in resource)){
                    this.$set(resource, this.pivotCrossResources, {
                        'order': this.form.crossresources.length + 1,
                        'name_feature_type_property_id': null,
                        'descr_feature_type_property_id': null,
                    });
                }
                // if(!('fields' in resource)){
                //     this.$set(resource, 'fields', {'name': null, 'descr': null});
                // }

                this.form.crossresources.push(resource);
                if(callback && typeof callback === "function"){
                    callback(resource.id, idx);
                }
            }
        },
        removeCrossResource(idx) {
            if(this.readonlyFormItem){
                return;
            }

            this.$refs.tblResources.prependItem(this.form.crossresources[idx]);
            this.form.crossresources.splice(idx, 1);
        },
    },
    watch: {
        'form.resources': {
            handler(value, oldValue){
                this.forceDirtyForm(value, 'resources');
                this.updateOrderItems();
            },
            deep: true,
        },
        'form.crossresources': {
            handler(value, oldValue){
                this.forceDirtyForm(value, 'crossresources');
                // this.updateOrderItems();
            },
            deep: true,
        },
    },
};